import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "view_module", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleGrid && _ctx.toggleGrid(...args))),
    class: "ml-2 flex"
  }, [
    _hoisted_1,
    _createElementVNode("span", null, _toDisplayString(_ctx.grid), 1)
  ]))
}